// extracted by mini-css-extract-plugin
export default {"Container":"CounterInput_Container__KVUvH","ControlButton":"CounterInput_ControlButton__ky9OZ","Input":"CounterInput_Input__3b-aC"};